<template>
  <div id="scrollDiv">
    <div class="titleStyle">
      <p class="paper-title">
        {{ paperTitle }}
      </p>
    </div>
    <div v-for="(item,index) in questionAndAnswer" :key="index">
      <div class="titleType">
        <p>{{ item.name }}</p>
      </div>
      <div style="padding-bottom: 10px;" v-for="(item1,index1) in item.questionItems"
           :key="index1">
        <a :id="'q' + item1.itemOrder">
          <radioSubject v-if="(item1.questionType === 0) || (item1.questionType === 1) "
                        :subjectId="item1.itemOrder" :questionBody="item1" :isDis="true" :haveAnswer="true">
          </radioSubject>
          <checkSubject v-if="item1.questionType === 2" :subjectId="item1.itemOrder" :questionBody="item1"
                        :isDis="true" :haveAnswer="true"></checkSubject>
          <shortAnswerSubject v-if="item1.questionType === 3" :subjectId="item1.itemOrder"
                              :questionBody="item1" :isDis="true" :haveAnswer="true">
          </shortAnswerSubject>
          <programmingSubject v-if="item1.questionType === 4" :subjectId="item1.itemOrder"
                              :questionBody="item1" :isDis="true" :haveAnswer="true">
          </programmingSubject>
          <blankSubject v-if="item1.questionType === 5" :subjectId="item1.itemOrder"
                        :questionBody="item1" :isDis="true" :haveAnswer="true">
          </blankSubject>
        </a>
      </div>

      <el-divider></el-divider>
    </div>
  </div>
</template>

<script>
import radioSubject from "@/components/radioSubject.vue"
import checkSubject from "@/components/checkSubject.vue"
import shortAnswerSubject from "@/components/shortAnswerSubject.vue"
import programmingSubject from "@/components/programmingSubject.vue"
import programmingSubjectMore from "@/components/programmingSubjectMore.vue"
import blankSubject from "@/components/blankSubject.vue"

export default {
  watch: {
    maodian: {
      handler: function (n, o) {
        // console.log(this.maodian)

        var target = document.querySelector(this.maodian);

        // document.getElementById("scrollDiv").parentNode.scrollTo(0, (target.offsetTop - 40))

        this.scrollAnimation(document.getElementById("scrollDiv").parentNode.scrollTop, (target.offsetTop -
            180))
      },
      deep: true
    }
  },
  props: {
    questionAndAnswer: {
      type: Array,
      default: () => []
    },
    maodian: {
      type: String,
      default: '#1'
    },
    paperTitle: {
      type: String,
      default: '试卷标题'
    }
  },
  components: {
    radioSubject,
    checkSubject,
    blankSubject,
    shortAnswerSubject,
    programmingSubject,
    programmingSubjectMore
  },
  mounted() {
    // console.log(this.questionAndAnswer)
  },
  data() {
    return {
      isAnswer: [],
    }
  },
  methods: {
    scrollAnimation(currentY, targetY) {

      // 计算需要移动的距离
      let needScrollTop = targetY - currentY + 110;
      let _currentY = currentY;
      setTimeout(() => {
        // 一次调用滑动帧数，每次调用会不一样
        const dist = Math.ceil(needScrollTop / 10);
        _currentY += dist;
        window.scrollTo(_currentY, currentY);
        document.getElementById("scrollDiv").parentNode.scrollTo(_currentY, currentY)
        // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
        if (needScrollTop > 10 || needScrollTop < -10) {
          this.scrollAnimation(_currentY, targetY)
          // window.scrollTo(_currentY, currentY);
        } else {
          window.scrollTo(0, _currentY);
          // document.getElementById("scrollDiv").parentNode.scrollTo(0, _currentY)
        }
      }, 1)
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__header {
  background-color: #FFFFFF;
  border: none;
  border-bottom: none;
  padding-left: 0px;
  padding-right: 10px;
}

::v-deep .el-card__body {
  padding-left: 0px;
  padding-right: 10px;
}

a {
  text-decoration: none !important;
}

.titleStyle {
  width: 100%;
  padding: 20px 0 28px;
  margin-bottom: 28px;
  text-align: center;

  .paper-title {
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
    color: #1a1a2e;
    letter-spacing: 1px;
    margin: 0;
  }
}

.titleType {
  width: 100%;
  height: 44px;
  background-color: #f5f7fa;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 0 24px;
  box-sizing: border-box;

  p {
    font-size: 17px;
    font-weight: 600;
    line-height: 44px;
    color: #303133;
    margin: 0;
  }
}




::v-deep .el-card {
  border: none;
  box-shadow: none;
  border-bottom: 1px solid #ebeef5;
  border-radius: 0;
}

::v-deep .el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  box-shadow: none;
}

</style>
